import { IconButton } from '@trg/tlw-ui-component';
import { useMiniCartApi } from '../../../common';
import { useMemo } from 'react';
import { useLayoutStore } from '../../../layout';
import clsx from 'clsx';

export function Cart() {
  const isAddingToCart = useLayoutStore.use.isAddingToCart();

  const { data } = useMiniCartApi();
  const count = useMemo(
    () => Number(data?.rtnJson.Count),
    [data?.rtnJson.Count]
  );

  return (
    <IconButton
      className={clsx(
        'tlw-flex tlw-items-center tlw-p-0 tlw-text-2xl lg:tlw-text-xl',
        isAddingToCart && 'tlw-text-txt-core'
      )}
      icon={isAddingToCart ? 'CartCheck' : 'Cart'}
      href={data?.rtnJson.minicartCheckoutUrl}
      square
    >
      <span className="tlw-txt-en-body-1 tlw-px-1">{count > 0 && count}</span>
    </IconButton>
  );
}
